/**
 * 弹窗模块
 *
 * @author mingxin.huang
 * @update 2014.11.04
 *
 * show        : 在页面内插入一个弹出框,
 * showCommon  : 简易提示框,
 * showConfirm : 确认提示框,
 * showMask    : 显示mask,
 * hideMask    : 隐藏mask,
 * hidePopup   : 隐藏弹出框
 *
 */

$.module('MM.ui.popup', function () {
  var _popupTmpl =
    '\
		<div id="<%=id%>" class="popup  <%= blank ? "popup-blank" : "" %> <%= newUi ? "ui-popup" : "" %>  <%=classes? classes : ""%>">\
			<% if (!noTitle) { %>\
				<div class="popup-hd fix">\
                    <div class="popup-hd-title"><%=title%></div>\
                    <%if(showCloseBtn) {%>\
                        <a class="popup-hd-close popup-close" title="关闭" href="javascript:;"><i class="iconfont <%= newUi ? "icon-close" : "icon-fucengguanbi" %> "></i></a>\
                    <%}%>\
				</div>\
			<% } %>\
			<div class="popup-content fix">\
                <% if (showContentClose) { %>\
                    <a class="content-icon-close iconfont icon-close" href="javascript:MM.ui.popup.hide()" ></a>\
                <% } %>\
                <%=content%>\
            </div>\
			<% if (footer) { %>\
				<div class="popup-footer fix"><%=footer%></div>\
			<% } %>\
		</div>\
	';

  var currentZIndex = 0;

  var currOptions = {};

  /**
   * 在页面内插入一个弹出框，页面上同时只会存在一个popup
   * 每次生成前会清除原有的popup
   * @param  {[Object]} options [弹出框参数]
   * options = {
   *		id : String, //弹出框id
   *		classes : String, //类名
   *		width : Number, //宽度
   *		height : Number, //高度
   *		top : Number, //离页面顶部的高度
   *		left : Number, //离页面左面的高度
   *		center : Boolean,//是否在页面上居中
   *		title : String, //弹出框头部的内容可以是html或者是string
   *		noTitle : Boolean, //是否不需要title
   *		content : String, //中部内容
   *		footer : String, //底部内容
   *		noMsk : Boolean, //是否不显示掩盖层
   *		disableMsk : Boolean, //是否让掩盖层点击无效
   *		enableDrag : Boolean, //是否支持拖拽
   *		force : Boolean, //是否强制更换重新创建弹出框，废除掉已经存在的，默认为true
   *      appendCallback : Function, //弹出框插入页面时的回调函数，后面尽量不用，
   *      						   //这个操作操作为同步操作，不需要回调
   *      closeCallback:关闭按钮的callback
   *      onBeforeClose:关闭之前回调
   *      showCloseBtn: 是否显示关闭按钮
   *      showContentClose:是否显示content内的close按钮
   * }
   * @return {Jquery}         一个弹出框的jQuery对象
   */
  function _show(options) {
    currOptions = $.extend(
      {
        id: 'popup-' + MM.common.getRangeNum(100000, 999999),
        classes: '',
        width: 'auto',
        height: 'auto',
        top: '50%',
        left: '50%',
        bottom: 'auto',
        right: 'auto',
        center: false,
        title: '提示',
        noTitle: false,
        showCloseBtn: true,
        content: '',
        footer: '',
        noMsk: false,
        disableMsk: false,
        solidMsk: false, //是否是非透明的遮盖层
        enableDrag: false,
        appendCallback: null,
        closeCallback: null,
        onBeforeClose: null,
        force: true,
        autoScroll: false,
        disableHideAnim: false, //是否关闭隐藏时的动画
        showContentClose: false,
        blank: false,
        newUi: true,
      },
      options,
    );

    // 如果在这个popup出现前已经有一个popup则之前的popup消失无动画
    if ($('.popup').length > 0) {
      currOptions.disableHideAnim = true;
    }
    if (currOptions.force) {
      //先清除原来的popup
      _hidePopup(true);
    } else {
      var $popup = $('#' + currOptions.id);
      if ($popup.length) {
        return $popup;
      } else {
        // _hidePopup(true);
      }
    }

    var htmlStr = $.template(_popupTmpl, currOptions),
      $currPopup = $(htmlStr).css({
        top: currOptions.top,
        left: currOptions.left,
        bottom: currOptions.bottom,
        right: currOptions.right,
      });

    if (currOptions.autoScroll) {
      $currPopup
        .find('.popup-content')
        .css('overflowY', 'auto')
        .height((parseInt(currOptions.height) || 300) - 81);
    }
    if (currOptions.width != 'auto') {
      $currPopup.width(currOptions.width);
    }
    if (currOptions.height != 'auto') {
      $currPopup.height(currOptions.height);
    }

    // 插入到body中
    $('body').append($currPopup);

    if (currentZIndex) {
      currentZIndex += 2;
      $currPopup.css('zIndex', currentZIndex);
    } else {
      currentZIndex = parseInt($currPopup.css('zIndex'));
    }
    // 显示mask
    if (!currOptions.noMsk) {
      _showMask(currOptions.id, currOptions.solidMsk, currOptions.disableMsk);
    }
    MM.core.debug('currentZIndex', currentZIndex);

    $currPopup.effect('fadeInDown');

    // 居中处理
    if (currOptions.center) {
      var ml = $.isNumeric(currOptions.width)
          ? -currOptions.width / 2
          : -$currPopup.width() / 2,
        mt = $.isNumeric(currOptions.height)
          ? -currOptions.height / 2 - 20
          : -$currPopup.height() / 2 - 20;

      $currPopup.css({
        marginLeft: ml,
        marginTop: mt,
      });
    }

    // 根据屏幕大小调整所需要用到的css属性
    // if ($currPopup.height() * 1.5 < screen.height && !MM.core.isIE6()) {
    // 	$currPopup.css('position', 'fixed');
    // }

    // 绑定基础事件
    _registerPopupEvents($currPopup, currOptions);

    // 根据是否要拖动增加拖动事件
    if (currOptions.enableDrag) {
      $currPopup.find('.popup-hd').addClass('popup-move');
      _registerMovePopupEvents();
    }

    // 执行插入的回调函数
    if ($.isFunction(currOptions.appendCallback)) {
      currOptions.appendCallback($currPopup);
    }

    return $currPopup;
  }

  /**
   * 对弹出框进行事件绑定
   * @param  {[type]} $popup [description]
   * @return {[type]}        [description]
   */
  function _registerPopupEvents($popup, options) {
    MM.core.debug('popup id', $popup.attr('id'));
    var close = (function (id) {
      return function () {
        MM.core.debug('popup close');
        _hidePopup(false, id, options);
      };
    })($popup.attr('id'));
    // 绑定关闭按钮点击事件
    $popup.find('.popup-close,.close').click(close);
  }

  // 注册移动弹框事件
  var _isRegistered = false,
    _isDragging = false,
    _mousePos = {
      x: 0,
      y: 0,
    },
    _popupPos = {
      left: 0,
      top: 0,
    },
    $currPopup = null;

  function _registerMovePopupEvents() {
    if (_isRegistered) {
      return;
    }
    _isRegistered = true;

    $('body').delegate('.popup .popup-move', 'mousedown', function (e) {
      _isDragging = true;

      var $this = $(this),
        $parent = $this.parent();

      _popupPos.left = parseInt($parent.css('left').slice(0, -2), 10);
      _popupPos.top = parseInt($parent.css('top').slice(0, -2), 10);
      _mousePos.x = e.pageX;
      _mousePos.y = e.pageY;

      $currPopup = $this.parent();

      if (e && e.preventDefault) {
        e.preventDefault();
      } else {
        window.event.returnValue = false;
      }
      return false;
    });

    $('body').delegate('.popup .popup-move', 'mouseup', function (e) {
      _isDragging = false;

      $currPopup = null;
    });

    $('body').on('mouseup', function (e) {
      _isDragging = false;

      $currPopup = null;
    });

    $('body').on('mousemove', function (e) {
      if (_isDragging === false || $currPopup === null) {
        return;
      }

      $currPopup.css({
        left: _popupPos.left + (e.pageX - _mousePos.x),
        top: _popupPos.top + (e.pageY - _mousePos.y),
      });
    });
  }

  /**
   * 隐藏弹出框
   */
  function _hidePopup(disableHideAnim, id, options) {
    var opts = options || {};
    var _hidePopupCallback = opts.hidePopupCallback, //关闭遮盖层时的回调函数
      _closeCallback = opts.closeCallback,
      _onBeforeClose = opts.onBeforeClose;

    clearTimeout(commonTimeoutId);
    var shouldClose = true; // 是否关闭 弹窗
    if ($.isFunction(_onBeforeClose)) {
      shouldClose = _onBeforeClose();
      _onBeforeClose = null;
    }

    if (shouldClose === false) {
      return;
    }

    var wrapperStr = '#' + id + ',#' + id + '-mask';
    if (!id) {
      wrapperStr = '.popup,.popup-mask';
    }

    if (disableHideAnim === true) {
      $(wrapperStr).remove();
    } else {
      if (MM.core.isIE8() || MM.core.isIE7() || MM.core.isIE6()) {
        $(wrapperStr).fadeOut();
      } else {
        if (!id) {
          $('.popup').effect('fadeOutUp', function () {
            $(wrapperStr).remove();
          });
        } else {
          $('#' + id).effect('fadeOutUp', function () {
            $(wrapperStr).remove();
          });
        }
      }
    }

    if ($.isFunction(_hidePopupCallback)) {
      _hidePopupCallback();

      _hidePopupCallback = null;
    }

    if ($.isFunction(_closeCallback)) {
      _closeCallback();

      _closeCallback = null;
    }
  }

  /**
   * 显示mask
   * @param  {Boolean} isSolid 是否是实色背景
   * @param  {Boolean} isClickDisable 点击是否无效
   */
  function _showMask(id, isSolid, isClickDisable) {
    var $mask = $(
      '<div id="' +
        id +
        '-mask" data-id="' +
        id +
        '" class="popup-mask"></div>',
    );

    if (currentZIndex) {
      $mask.css('zIndex', currentZIndex - 1);
    }

    if (isSolid) {
      $mask.addClass('solid-mask');
    } else {
      $mask.removeClass('solid-mask');
    }

    $('body').append($mask);
    $mask.show();

    if (isClickDisable) {
      return;
    }

    $mask.on('click', function () {
      _hidePopup(false, $(this).data('id'));
    });
  }

  /**
   * 隐藏mask
   */
  function _hideMask() {
    $('#mask').remove();
  }

  var commonTimeoutId;

  /**
   * 简易提示框，如果消息为纯文字提示建议使用MM.ui.messager下的方法
   * @param  {String}   text     文本
   * @param  {Number}   second   多少秒之后关闭
   * @param  {Function} callback 关闭后的回调函数
   */
  function _showCommon(text, second, callback) {
    if (!text) {
      return;
    }

    var params = {
      id: 'common-popup',
      width: 400,
      height: 'auto',
      center: true,
      title: '提示',
      content: '<p>' + text + '</p>',
      closeCallback: callback,
    };

    var options = _.last(arguments);

    if (_.isObject(options)) {
      params = _.assign({}, params, options);
    }

    var $popup = _show(params);

    if ($.isNumeric(second)) {
      commonTimeoutId = setTimeout(_hidePopup, second * 1000);
    }

    return $popup;
  }

  /**
   * 确认提示框
   * @param  {String} title           提示title
   * @param  {String} text            提示内容文本
   * @param  {Function} confirmCallback 确定回调函数
   * @param  {Function} cancelCallback  取消回调函数
   * @param  {String} confirmText     取消按钮文字
   * @return {JQuery}                 弹窗对象
   */
  function _showConfirm(
    title,
    text,
    confirmCallback,
    cancelCallback,
    confirmText,
    cancelText,
  ) {
    var popupId = 'confirm-popup' + MM.common.getRangeNum(10000, 99999);
    confirmText = confirmText || '确定';

    var fn = function ($selector) {
      $selector.find('.btn-danger').one('click', function (e) {
        _hidePopup(true, popupId);

        if ($.isFunction(confirmCallback)) {
          confirmCallback($selector);
        }
      });

      $selector
        .find('.btn-default, .close,.close-btn')
        .one('click', function (e) {
          _hidePopup(true, popupId);

          if ($.isFunction(cancelCallback)) {
            cancelCallback();
          }
        });
    };

    var footer =
      '<a href="javascript:void(0);" class="btn  btn-danger btn-lg">' +
      confirmText +
      '</a>';

    if (cancelText) {
      footer =
        '<a href="javascript:void(0);" class="btn  btn-default  btn-lg">' +
        cancelText +
        '</a>' +
        footer;
    }

    var params = {
      id: popupId,
      classes: 'confirm-popup',
      width: 400,
      height: 'auto',
      disableMsk: true,
      center: true,
      title: title || '提示',
      content: text || '确定？',
      footer: footer,
      newUi: true,
      force: false,
      appendCallback: fn,
    };

    var options = _.last(arguments);

    if (_.isObject(options) && !_.isFunction(options)) {
      params = _.assign({}, params, options);
    }

    return _show(params);
  }

  function _showSuccess(options) {
    var tmpl =
      '\
        <div class="success-popup-content">\
            <div class="happy-icon"></div>\
            <div class="tip-conent">\
                <p class="tip-title"><%= tipTitle %></p>\
                <p class="tip-text"><%= tipText %></p>\
            </div>\
            <div class="tip-extra"><%= tipExtra %></div>\
            <% if(okBtnText) { %>\
                <div class="ui-form-btn" onclick="javascript:MM.ui.popup.hide();"> <%= okBtnText %> </div>\
            <% } %>\
        </div>';

    options = _.assign(
      {
        newUi: true,
        width: 360,
        center: true,
        title: '操作成功',
        tipTitle: '操作成功!',
        tipText: '',
        tipExtra: '',
        okBtnText: '',
        duration: 0,
      },
      options,
    );

    options.content = $.template(tmpl, options);
    duration = options.duration;
    callback = options.callback;

    if (duration || callback) {
      options.appendCallback = function ($popup) {
        if (duration) {
          setTimeout(function () {
            callback && callback($popup);
          }, duration);
        } else {
          callback && callback($popup);
        }
      };
    }

    _hidePopup();
    _show(options);
  }

  function _showH5(title, h5Url) {
    if (window['wwwPublic']) {
      wwwPublic.UiModal.iframe({
        title: title,
        url: h5Url,
        isH5Popup: true,
      });
      return;
    }
    _show({
      id: 'h5Popup',
      classes: 'h5Popup',
      width: 428,
      height: 668,
      center: true,
      // noMsk: true,
      title: title,
      force: true,
      content: $.template(
        '<iframe id="h5PopupIframe" src="<%= url %>" name="mainFrame" frameborder="0" style="padding: 0; width: 100%;"></iframe>',
        {
          url: MM.core.getRoot(
            h5Url +
              (h5Url.indexOf('?') > 0 ? '&' : '?') +
              'access_token=' +
              MM.user.getToken() +
              '&hide_back=1',
            'h5',
          ),
          // url: 'http://localhost.2339.com:9200/app/star?access_token='+MM.user.getToken(),
          // url: MM.core.getRoot('app/game/egg?room_id='+MM.live.room.getRoomId(),'h5'),
        },
      ),
      appendCallback: function () {
        var frame = document.getElementById('h5PopupIframe').contentWindow;
        MM.messenger.addTarget(frame, 'child-h5', function () {
          MM.ui.popup.hide(false, 'h5Popup');
        });
      },
      onBeforeClose: function () {
        MM.messenger.removeTarget('child-h5');
      },
    });
  }

  return {
    show: _show,
    showH5: _showH5,
    showCommon: _showCommon,
    showConfirm: _showConfirm,
    showSuccess: _showSuccess,
    showMask: _showMask,
    hideMask: _hideMask,
    hide: _hidePopup,
  };
});
